import { Component, createRef } from "preact"
import Badge from "./personalized/badge"
import { widgetV2Url } from "../constants"
import CopyButton from "./personalized/copy-button"
import { __ } from "../../locales"

class IframePreview extends Component {
  constructor(props) {
    super(props)

    this.state = {
      shouldInitScript: false,
      template: null,
      isLoading: false,
      shouldLoad: props.shouldLoad,
    }
    this.codeRef = createRef()
  }

  componentDidMount(props) {
    this.callScript()
  }

  componentWillUnmount() {
    this.cleanScript()
  }

  async componentWillReceiveProps(nextProps) {
    if (nextProps.shouldLoad !== this.state.shouldLoad) {
      this.setState({
        shouldLoad: nextProps.shouldLoad,
      })
    }
    if (nextProps.url !== this.props.url) {
      await this.cleanScript()
      this.callScript(nextProps.url)
    }
  }

  componentDidUpdate(previousProps, previousState, snapshot) {
    if (!previousState.shouldInitScript && this.state.shouldInitScript) {
      this.initScript()
      this.setState({ shouldInitScript: false })
    }
  }

  componentDidMount() {
    if (this.state.shouldInitScript) {
      this.initScript()
      this.setState({ shouldInitScript: false })
    }
  }

  async cleanScript() {
    return new Promise((res) => {
      setTimeout(() => {
        const iframeScript = document.querySelector(`#${this.props.widgetName}`)
        if (iframeScript) {
          window.onmessage = () => {}
          iframeScript.remove()
        }
        res()
      }, 0)
    })
  }

  initScript() {
    const iframeScript = document.querySelector(`#${this.props.widgetName}`)
    if (!iframeScript) {
      const script = document.createElement("script")
      script.setAttribute("id", this.props.widgetName)
      script.setAttribute("type", "text/javascript")
      script.setAttribute(
        "src",
        `${widgetV2Url}/doctify-widget-autoresize-plugin.js?tenantId=athena-uk&widgetName=${this.props.widgetName}&containerId=${this.props.id}`
      )
      document.head.appendChild(script)
    }
  }

  callScript(url) {
    if (url || this.props.url) {
      this.setState({
        isLoading: true,
      })
      fetch(url || this.props.url)
        .then((r) => r.text())
        .then((template) => this.setState({ template, shouldInitScript: true }))
        .catch(() => this.setState({ template: null }))
        .finally(() => this.setState({ isLoading: false }))
    }
  }

  render({ fixedWidth, fixedHeight, defaultHeight }, { template, shouldLoad }) {
    if (this.state.isLoading) {
      return (
        <div
          style={{ height: defaultHeight }}
          className="d-flex justify-content-center"
        >
          <div
            className="spinner-border text-primary"
            role="status"
            style="width: 4rem; height: 4rem;"
          >
            <span className="sr-only" />
          </div>
        </div>
      )
    }
    if (!template || !shouldLoad) {
      return <div style={{ height: defaultHeight }} />
    }
    return (
      <>
        <div className="code-snippet">
          <div className={"preview mb-5"}>
            <div
              className={"d-flex justify-content-between"}
              style={{ gap: "15px" }}
            >
              <p>{__("global.preview")}</p>
              <Badge
                text={this.props.badgeTitle}
                fontColor={this.props.badgeFontColor}
                bgColor={this.props.badgeColor}
                smaller
              />
            </div>
            <div
              className={"container d-flex align-items-center flex-column"}
              dangerouslySetInnerHTML={{ __html: template }}
              style={{
                ...(fixedWidth ? { width: fixedWidth } : {}),
                ...(fixedHeight ? { height: fixedHeight } : {}),
              }}
            />
          </div>
          <p className={"code-snippet-title mb-3"}>
            {__("copy_code_disclaimer")}
          </p>
          <div className="pre-code">
            <CopyButton textRef={this.codeRef} />
            <code ref={this.codeRef}>{template}</code>
          </div>
        </div>
      </>
    )
  }
}

export default IframePreview
